<template>
  <section class="relative min-h-screen flex items-center overflow-hidden pt-16">
    <div class="absolute inset-0 bg-white dark:bg-dark transition-colors duration-300">
      <img v-if="isDark" src="/ciobai_hero_background.webp" alt="" class="absolute inset-0 w-full h-full object-cover" />
      <img v-else src="/ciobai_hero_background_light.webp" alt="" class="absolute inset-0 w-full h-full object-cover opacity-40" />
    </div>

    <div class="container mx-auto px-4 relative z-10">
      <div class="max-w-4xl">
        <div class="inline-flex items-center gap-2 rounded-full bg-gray-100 dark:bg-white/[0.06] border border-gray-200 dark:border-white/[0.08] px-4 py-1.5 text-[13px] font-medium text-gray-500 dark:text-gray-400 mb-10 backdrop-blur-sm transition-colors duration-300">
          <span class="relative flex h-2 w-2">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          {{ $t('hero.freeConsultation') }}
        </div>

        <h1 class="text-[clamp(2.5rem,6vw,5.5rem)] font-extrabold leading-[1.05] tracking-[-0.03em] mb-8">
          <span class="text-gray-900 dark:text-white transition-colors duration-300">{{ $t('hero.title') }}</span>
          <br />
          <span class="hero-gradient-text">{{ $t('hero.subtitle') }}</span>
        </h1>

        <p class="text-lg md:text-xl text-gray-500 dark:text-gray-400 max-w-2xl leading-relaxed mb-12 font-medium transition-colors duration-300">
          {{ $t('hero.description') }}
        </p>

        <div class="flex flex-col sm:flex-row items-start gap-4 mb-16">
          <router-link
            to="/contact"
            class="group inline-flex items-center h-14 px-8 bg-gray-900 dark:bg-white text-white dark:text-dark font-bold text-[15px] rounded-xl transition-all duration-300 hover:bg-gray-800 dark:hover:bg-gray-100 hover:shadow-lg"
          >
            {{ $t('hero.cta.prototype') }}
            <ArrowRight class="ml-2.5 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </router-link>

          <button
            @click="scrollToQuote"
            class="inline-flex items-center h-14 px-8 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white font-medium text-[15px] rounded-xl transition-all duration-300 border border-gray-200 dark:border-white/[0.08] hover:border-gray-400 dark:hover:border-white/20 hover:bg-gray-50 dark:hover:bg-white/[0.04]"
          >
            {{ $t('hero.cta.quickQuote') }}
          </button>
        </div>

        <div class="flex items-center gap-6 flex-wrap">
          <div class="flex items-center gap-1.5">
            <div class="flex -space-x-1">
              <Star v-for="i in 5" :key="i" class="h-3.5 w-3.5 text-yellow-500 fill-yellow-500" />
            </div>
            <span class="text-sm text-gray-400 dark:text-gray-500 ml-1">{{ $t('hero.socialProof') }}</span>
          </div>
          <div class="h-4 w-px bg-gray-200 dark:bg-white/10"></div>
          <span class="text-sm text-gray-400 dark:text-gray-500">{{ $t('hero.partnership') }}</span>
        </div>
      </div>
    </div>

    <div class="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white dark:from-dark to-transparent z-10 transition-colors duration-300"></div>
  </section>
</template>

<script setup>
import { Star, ArrowRight } from 'lucide-vue-next'
import { useTheme } from '../composables/useTheme'

const { isDark } = useTheme()

const scrollToQuote = () => {
  const quoteSection = document.getElementById('quick-quote')
  if (quoteSection) {
    quoteSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    window.location.href = '/contact?tab=quote'
  }
}
</script>

<style scoped>
.hero-gradient-text {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #2563eb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>
